import * as _ from 'lodash-es';
import {Cell} from './cell';
import {Edge} from './edge';
import {CellActionType} from './layout-actions/cell-action-type';
import {Widget} from './widget/widget';

export interface LayoutChangedItems {
    cells?: Cell[];
    edges?: Edge[];
    widgets?: Widget[];
    edge?: Edge;
    cell?: Cell;
    widget?: Widget;
}

export interface LayoutChangeRecord extends LayoutChangedItems {
    message: string;
    actionType: CellActionType;
}

export interface LayoutChangesCommitResult {
    removedCells: Cell[];
    destroyedWidgets: Widget[];
    newWidgets: Widget[];
}

export class LayoutChanges {

    public cells: Cell[] = [];
    public edges: Edge[] = [];
    public widgets: Widget[] = [];
    public records: LayoutChangeRecord[] = [];
    public commitResult: LayoutChangesCommitResult;

    public add(
        message: string,
        changedItems: LayoutChangedItems,
        {silent = false, actionType = null}: {silent?: boolean, actionType?: CellActionType} = {}
    ): LayoutChanges {
        const cells: Cell[] = changedItems.cells || changedItems.cell && [changedItems.cell];
        const edges: Edge[] = changedItems.edges || changedItems.edge && [changedItems.edge];
        const widgets: Widget[] = changedItems.widgets || changedItems.widget && [changedItems.widget];

        this.records.push({cells, edges, widgets, message, actionType});

        this.cells = _.union(this.cells, cells);
        this.edges = _.union(this.edges, edges);
        this.widgets = _.union(this.widgets, widgets);

        if (!silent) {
            console.log('[LayoutChanges]', message, changedItems);
        }

        return this;
    }

    public append(layoutChanges: LayoutChanges): LayoutChanges {
        layoutChanges.records.forEach(record => this.registerRecord(record));

        return this;
    }

    public registerRecord(record: LayoutChangeRecord): LayoutChanges {
        return this.add(
            record.message,
            {
                cells: record.cells,
                edges: record.edges,
                widgets: record.widgets
            },
            {
                silent: true,
                actionType: record.actionType
            }
        );
    }

    public appendTo(layoutChanges: LayoutChanges): LayoutChanges {
        return layoutChanges.append(this);
    }

    public getChangesByActionType(...actionTypes: CellActionType[]): LayoutChanges {
        const filteredChanges: LayoutChanges = new LayoutChanges();

        this.records
            .filter(record => actionTypes.includes(record.actionType))
            .forEach(record => filteredChanges.registerRecord(record));

        return filteredChanges;
    }

}
